if(typeof lazySizes === 'undefined') {
	/*! lazysizes - v4.1.8 */
	!function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
	/*! ls.rias.min.ks - v4.1.8 */
	!function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

var onSale = false; 
var soldOut = false;
var newLabel = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {  
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		// Placeholder
		showPlaceholderProductList: true,
		placeholderProductPerRow: 6,
		enableOTP: true,
		separateRefineByFromFilter: true
}
};

(function() {
	BoostPFS.inject(this);
	
	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		newLabel = data.tags.join(',').includes('new'); // Check label new
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		// Add Grid Width class
		itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		// Add TAG Label
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Custom Images
		itemHtml = itemHtml.replace(/{{itemCustomImages}}/g, buildCustomImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		// wholesale
		itemHtml = itemHtml.replace(/{{wholesale}}/g, buildWholesale(data));

		// Add Review
		var itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml);
  
		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
		// itemActiveSwapClass
		var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
		// Add Color Swatches
  		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
  		itemHtml = itemHtml.replace(/{{itemCustomColorSwatches}}/g, buildCustomColorSwatches(data));
  		itemHtml = itemHtml.replace(/{{itemCustomColorSelectSwatches}}/g, buildCustomColorSelectSwatches(data));
  		itemHtml = itemHtml.replace(/{{itemCustomAddCart}}/g, buildCustomAddCart(data));
		  itemHtml = itemHtml.replace(/{{quickview}}/g, buildButton(data));		// Add data json
			itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		return itemHtml;
	};
	// Build Product List Item
	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// For List View
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		// Add Label
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		// Add TAG Label
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Custom Images
		itemHtml = itemHtml.replace(/{{itemCustomImages}}/g, buildCustomImages(data));
		// Add Review
		var itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		itemHtml = itemHtml.replace(/{{itemReviewHtml}}/g, itemReviewHtml);
		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
		// Description
		var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		itemDescription = (itemDescription.split(" ")).length > 35 ? itemDescription.split(" ").splice(0, 35).join(" ") + '...' : itemDescription.split(" ").splice(0, 35).join(" ");
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
		// itemActiveSwapClass
		var itemActiveSwapClass = boostPFSThemeConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
		itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
		// Add Color Swatches
  		itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
  		itemHtml = itemHtml.replace(/{{itemCustomColorSwatches}}/g, buildCustomColorSwatches(data));
  		itemHtml = itemHtml.replace(/{{itemCustomColorSelectSwatches}}/g, buildCustomColorSelectSwatches(data));
  		itemHtml = itemHtml.replace(/{{itemCustomAddCart}}/g, buildCustomAddCart(data));
		  			itemHtml = itemHtml.replace(/{{quickview}}/g, buildButton(data));
		  
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		return itemHtml;
		// End For List View
	};
	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildGridWidthClass() {
		var gridWidthClass = '';
		// On PC
		switch (boostPFSThemeConfig.custom.products_per_row) {
			case 2:
				gridWidthClass = 'boost-pfs-filter-grid-width-2';
				break;
			case 3:
				gridWidthClass = 'boost-pfs-filter-grid-width-3';
				break;
			case 5:
				gridWidthClass = 'boost-pfs-filter-grid-width-5';
				break;
			default:
				gridWidthClass = 'boost-pfs-filter-grid-width-4';
				break;
		}
		// On Mobile
		switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
			case 1:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
				break;
			case 3:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
				break;
			default:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
				break;
		}
		return gridWidthClass;
	}

	function buildImages(data) {
		var html = '';
		// Build Main Image
		var thumbUrl = Utils.getFeaturedImage(images, '{width}x');
		html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
			' alt="{{itemTitle}}" ' +
			'data-srcset="' + Utils.getFeaturedImage(images, '500x') + '" ' +
			'data-src="' + thumbUrl + '" ' +
			'data-widths="[260, 360]" ' +
			'data-sizes="auto" />';
		// Build Image Swap
		if (boostPFSThemeConfig.custom.active_image_swap) {
			var flipImageUrl = images.length > 1 ? Utils.optimizeImage(images[1]['src'],'{width}x') : thumbUrl;
			var flipImageSrcset = images.length > 1 ? Utils.optimizeImage(images[1]['src'],'500x') : Utils.getFeaturedImage(images, '800x');
			html += '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
			' alt="{{itemTitle}}" ' +
			'data-srcset="' + flipImageSrcset + '" ' +
			'data-src="' + flipImageUrl + '" ' +
			'data-widths="[260, 360]" ' +
			'data-sizes="auto" />';
		}
		return html;
	}

	// Build Custome Images
	function buildCustomImages(data) {
		var html = '';
		// Build Main Image
		var thumbUrl = Utils.getFeaturedImage(images, '{width}x');


		for(var k = 0; k < data.variants.length; k ++){
			if(data.variants[k].image !== null && data.variants[k].image){
				var variantImage = data.variants[k].image;
				var imageInfo = data.images_info.filter(function(image){
					return image.src === variantImage
				});

				if(imageInfo.length > 0){
					var imageID = imageInfo[0] !== undefined ? imageInfo[0].id : null;
				}
			}
		}

		html += `<div class="global-image-wrapper primary image-option image primary image-option hide-mobile image-option-featured-appear">
							<img class="image primary image-option hide-mobile image-option-featured-appear lazyloads lazy entered loaded" alt="{{itemTitle}}" src="` + Utils.getFeaturedImage(images, `500x`) + `"/>
						</div>`;

		if (data.variants[0].image != null) {
		    for (i in data.variants) {
		    	var variantImage = data.variants[i].image;
		    	var imageInfo = data.images_info.filter(function(image){
		    		return image.src === variantImage
		    	})

				if(imageInfo[0] !== undefined) {
					var imageID = imageInfo[0].id;
					var MainImg = `<div class="global-image-wrapper primary image-option">
													<img class="image primary image-option lazyloads Image--lazyLoads lazy  entered loaded" alt="{{itemTitle}}" src="` + Utils.getFeaturedImage(images, `500x`) + `" id="image` + imageID + `"/>
												</div>`
					if (i == 0) {
						html += `<div class="global-image-wrapper primary image-option-primary">
											<img class="image image-option-primary lazy  entered loaded" src="` + data.variants[i].image + `" id="image` + imageID + `"/>
										</div>`
					}
					else {
						html += `<div class="global-image-wrapper primary image-option-primary">
											<img class="image image-option-primary lazy entered loaded" src="` + data.variants[i].image + `" id="image` + imageID + `"/>
										</div>`
					}
				}
		    }
		}

		// Build Image Swap
		if (boostPFSThemeConfig.custom.active_image_swap) {
			var flipImageUrl = images.length > 1 ? Utils.optimizeImage(images[1]['src'],'{width}x') : thumbUrl;
			var flipImageSrcset = images.length > 1 ? Utils.optimizeImage(images[1]['src'],'500x') : Utils.getFeaturedImage(images, '500x');
			if(MainImg == undefined) {
				html += `
					<div class="product-slick-cons">
						<div class="global-image-wrapper primary secondary slicking ">
							<img class="image lazy entered loaded secondary slicking lazyloads Image--lazyLoads" alt="{{itemTitle}}" src="` + flipImageSrcset + `" />
						</div>
					</div>`;
			} else {
				html += `<div class="product-slick-cons">`
									+ MainImg 
									+ `
									<div class="global-image-wrapper primary secondary slicking ">
										<img class="image lazy entered loaded secondary slicking lazyloads Image--lazyLoads" alt="{{itemTitle}}" src="` + flipImageSrcset + `"/>
									</div>
								</div>`;
			}
			
		}
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_vendor) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html; 
	}

	function buildPrice(data) {
		const wholesale = $('.collection-products').data('wholesale');
		let baseDiscount = $('.collection-products').data('base-discount');
		let baseDiscount14k = $('.collection-products').data('base-discount-14k');
		const currencyCode = $('.collection-products').data('currency-code');
		// const price_key = `price_min_${currencyCode.toLowerCase()}`;
		const price_key = 'price_min';
		const compare_price_key = `compare_at_price_min_${currencyCode.toLowerCase()}`;

		if(!data.tags.includes('luxury') || data.tags.includes('14K Solid Gold')){
			baseDiscount = baseDiscount14k;
		}

		let html = '';
		if (boostPFSThemeConfig.custom.show_price) {
			html = '<p class="boost-pfs-filter-product-item-price cf price" style="padding-bottom:0">';
			if(wholesale) {
				const dd = 100 - baseDiscount;
				const discountedPrice = (data[price_key] * dd) / 100;
				html += `<span>${Utils.formatMoney(discountedPrice)} ${currencyCode}</span><strike>${Utils.formatMoney(data[price_key])} ${currencyCode}</strike>`;
			} else {

				if(dtag != "" && data.tags.includes(dtag))
				{
					if (priceVaries) {
						html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' '+ '</span>';
					}
					html += `<span class="boost-pfs-filter-product-item-sale-price">${Utils.formatMoney(data[price_key] * dpercent)} ${currencyCode}</span>`;
					html += `<s>${Utils.formatMoney(data[price_key])} ${currencyCode}</s>`;
				} else
				{
				if (onSale) {
					html += `<span class="boost-pfs-filter-product-item-sale-price">${Utils.formatMoney(data[price_key])} ${currencyCode}</span>`;
					html += `<s>${Utils.formatMoney(data[compare_price_key])} ${currencyCode}</s>`;
					diff = Math.round(((data[compare_price_key] - data[price_key]) * 100) / data[compare_price_key]);
					if(data.tags.includes("50D2021"))
					{
						diff = 50;
					}
					else if(data.tags.includes("40D2021"))
					{
						diff = 40;
					}
					else if(data.tags.includes("30D2021"))
					{
						diff = 30;
					}
					html += '<div class="price mt-5">('+diff+'% Off)</div>';
				} else {
					if (priceVaries) {
						html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label_basic.from) + ' '+ '</span>';
					}
					if(!data.tags.includes('luxury') || data.tags.includes('14K Solid Gold')){
						html += `<span class="boost-pfs-filter-product-item-regular-price">${Utils.formatMoney(data[price_key])} ${currencyCode}</span>`;
					}
				}
			}
			}
			
			html += '</p>';
		}

		if(data.tags.includes('14K Solid Gold')) {
		} else {
			if(data.tags.includes('luxury')){
				html = ''
			}
		}

		
		return html;
	}

	function buildWholesale(data) {
		console.log('data from wholesale:',data.tags.includes('luxury'))
		const currencyCode = $('.collection-products').data('currency-code');
		const price_key = `price_min`;
		let price = (!data.tags.includes('luxury') || data.tags.includes('14K Solid Gold')) ? `Retails at ${Utils.formatMoney(data[price_key])} ${currencyCode}. <br>`: ''
		let html = `<div class="product-each-name-price">
									<h4 class="cf mb-5">
										<a class="show-mobile product-title" href="${Utils.buildProductItemUrl(data)}">${data.title}</a>
									</h4>
									<p class="cf price">
										${price}<a href="/account">Log in</a> for wholesale price
									</p>
								</div>`
		return html;
	}

	function buildLabels(data) {
		// Build Sold out label		
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
			// soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml;
		}
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
			// saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
			saleLabel = boostPFSTemplate.saleLabelHtml;
		}
		// Build new label
		var newLabel2 = '';
		if (boostPFSThemeConfig.custom.show_sale_label && newLabel && !soldOut) {
			// saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
			newLabel2 = boostPFSTemplate.newLabelHtml;
		}
		var rtn = soldOutLabel + saleLabel + newLabel2;
		if (rtn == 'undefined') {
			return '';
		}
		return rtn;
		// return soldOutLabel + saleLabel + newLabel2;
	}
	// BUILD LABEL PRODUCT WITH TAGS
	function buildTagLabels(data, showall) {
		if (showall) {
			var tagLabel = '';
			if (data.tags) {
				for (var i = 0; i < data.tags.length; i++) {
					var tag = data.tags[i];
					if (tag.indexOf("pfs:label") !== -1) {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
						tagLabel += preTagLabel;
					}
				}
			}
		} else {
			var tagLabel = '';
			if (data.tags) {
				for (var i = data.tags.length - 1; i >= 0; i--) {
					tag = data.tags[i];
					if (tag.indexOf("pfs:label") !== -1) {
						var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
						tagLabel += preTagLabel;
						break;
					}
				}
			}
		}
		return tagLabel;
	}

	// Build Color Swatches
	function buildColorSwatches(data) {
	var colorSwatchesHtml = '';
	if (boostPFSThemeConfig.custom.display_item_swatch) {
		colorSwatchesHtml += '<ul class="boost-pfs-filter-item-swatch">';
		for (var index = 0; index < data.options.length; index++) {
			var option = data['options'][index].toLowerCase();
			if (option == 'color') {
				var colorlist = '';
				var color = '';
				var totalVariants = 0;
				for (var k = 0; k < data.variants.length; k++) {
					var variant = data['variants'][k];
					color = variant['options'][index];
					if (colorlist.indexOf(color) == -1) {
						if (totalVariants < 4) {
							var text = Utils.slugify(color);
							var border = text == 'white' ? 'border: 1px solid #cbcbcb;' : '';
							var backgroundImage = Utils.optimizeImage(variant.image, '24x');
							var dataImg = '';
							var dataColor = '#fff';
							dataColors = variant.option_color.toLowerCase().split(' ');
							var i = dataColors.length - 1;
							if (dataColors[i] !== '' && dataColors[i] !== 'colors') {
								dataColor = dataColors[i];
							}

							if (variant.image !== null) {
								dataImg = "data-img='" + Utils.optimizeImage(variant.image) + "'";
							} else {
								var _file = variant.option_color.toLowerCase().replace(/ /g, '-');
								backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + 'color-' + _file + '.png';
							}
							
							colorSwatchesHtml += '<li>';
							colorSwatchesHtml += '<div class="tooltip">' + color + '</div>';
							colorSwatchesHtml += '<label style="' + border + ' background-color: ' + dataColor + '; background-image: url(' + backgroundImage + ');" ' + dataImg + '></label>';

							//colorSwatchesHtml += '<label style="' + border + 'background-image: url(' + Utils.optimizeImage(variant.image, '24x') + ');"' + if (variant.image !== null){ + 'data-img="' + Utils.optimizeImage(variant.image) + '"' + } '></label>';
							colorSwatchesHtml += '</li>';

						}
						var templist = colorlist + color + ' ';
						colorlist = templist;

						totalVariants++;

					}
				}
				// if (totalVariants == 1) {
				// colorSwatchesHtml = '<ul class="boost-pfs-filter-item-swatch">';
				// }
				if (totalVariants > 4) {
					colorSwatchesHtml += '<li class="boost-pfs-filter-item-swatch-more">';
					colorSwatchesHtml += '<a href="{{itemUrl}}" title="More Color">+' + (totalVariants - 4) + '</a>';
					colorSwatchesHtml += '</li>';
					totalVariants = 0;
				}
			}
		}
		colorSwatchesHtml += '</ul>';
	}
	return colorSwatchesHtml;
	}




	// Build Custom Color Swatches (Shah)
	function buildCustomColorSwatches(data) {
	var colorSwatchesHtml = '';
	if (boostPFSThemeConfig.custom.display_item_swatch) {
		colorSwatchesHtml += '<div class="product-options-form mb-20 desktop-mb-10 cf">';
		colorSwatchesHtml += '<div class="product-each-form-error">Please select a color</div>';

		if (data.variants.length == 1) {			
			for(i = 0; i < data.options_with_values.length; i++)
			{
				values = data.options_with_values[i]["values"];
				var option = data['options'][i].toLowerCase();
				for(k = 0; k < values.length; k++)
				{
					for(j = 0; j < data.variants.length; j++)
					{
						values = data.variants[j].id;
						var variant = data['variants'][j];
						color = variant['options'][i];
						title_handle = data.tags;

					    var Gold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#d3b47b" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#d3b47b" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#d3b47b" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
					    var Silver = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#dbdbdb" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#dbdbdb" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#dbdbdb" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
					    var RoseGold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#d8996b" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#d8996b" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#d8996b" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
					    var WhiteGold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#dbdbdb" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#dbdbdb" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#dbdbdb" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
					    var YellowGold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#ceb582" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#ceb582" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#ceb582" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'

					   

					    if (color == 'Gold' || title_handle.includes('Gold')){
					    	//console.log(c.innerHTML + "Gold Color Swatch");
					    	color = '' + Gold;
					    	//c.data = 'content2';
					    	//c.setAttribute("data-variant", "Gold");
					    } else if (color == 'Silver' || title_handle.includes('Silver') || color.includes('Silver') ){
					    	color = '' + Silver;
					    	//c.setAttribute("data-variant", "Silver");

					    } else if (color == 'Rose gold' || color == 'Rose Gold' || title_handle.includes('Rose gold') || title_handle.includes('Rose Gold') ){
					    	color = '' + RoseGold;
					    	//c.setAttribute("data-variant", "Rose gold");
							} else if (color == 'White gold' || color == 'White Gold' ){
					    	color = '' + WhiteGold;
					    	//c.setAttribute("data-variant", "White gold");
							} else if (color == 'Yellow gold' || color == 'Yellow Gold' ){
					    	color = '' + YellowGold;
					    	//c.setAttribute("data-variant", "Yellow gold");
					    } else{
					    	color = "";
					    }



					    colorSwatchesHtml += '<div data-inventory-qty="'+ data.variants[j].inventory_quantity +'" data-variant-id="' + values + '"' + 'data-url="' + Utils.buildProductItemUrl(data)+'?variant='+data.variants[j].id+ '"' + 'class="product-each-selection product-option-con  desktop-mb-10 show-mobile-inline-block ">';
					    colorSwatchesHtml += '<div class="hi product-option-title-con flex-row indiviudal-swatch cursor">' + color + '</div>';
					}
				
				}
			}
		} else
		{

			for(i = 0; i < data.options_with_values.length; i++){
				var optionss = data['options'][i];
				var frags = optionss.split('_');
				for (i=0; i<frags.length; i++) {
			      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
			      var optionss = frags.join(' ');
			    }
			}

			if (optionss.includes('Size') || optionss.includes('Length') ){
				for(i = 0; i < data.options_with_values.length; i++)
				{
					values = data.options_with_values[i]["values"];
					var option = data['options'][i].toLowerCase();
					values = data.variants[i].id;
					var variant = data['variants'][i];
					color = variant['options'][i];
					title_handle = data.tags;

				    var Gold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#d3b47b" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#d3b47b" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#d3b47b" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
				    var Silver = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#dbdbdb" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#dbdbdb" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#dbdbdb" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
				    var RoseGold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#d8996b" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#d8996b" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#d8996b" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
						var WhiteGold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#dbdbdb" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#dbdbdb" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#dbdbdb" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
						var YellowGold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#ceb582" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#ceb582" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#ceb582" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
					let color_exist = true;
				   

				    if (color == 'Gold' || title_handle.includes('Gold')){				    	
				    	color = '' + Gold;
				    	//c.data = 'content2';
				    	//c.setAttribute("data-variant", "Gold");
				    } else if (color == 'Silver' || title_handle.includes('Silver') || color.includes('Silver') ){
				    	color = '' + Silver;
				    	//c.setAttribute("data-variant", "Silver");

				    } else if (color == 'Rose gold' || color == 'Rose Gold' || title_handle.includes('Rose gold') || title_handle.includes('Rose Gold') ){
				    	color = '' + RoseGold;
				    	//c.setAttribute("data-variant", "Rose gold");
						} else if (color == 'White gold' || color == 'White Gold' ){
							color = '' + WhiteGold;
							//c.setAttribute("data-variant", "White gold");
						} else if (color == 'Yellow gold' || color == 'Yellow Gold' ){
							color = '' + YellowGold;
							//c.setAttribute("data-variant", "Yellow gold");
				    } else{
						color_exist = false;
				    	color = variant['options'][i];
				    }

				    colorSwatchesHtml += '<div data-inventory-qty="'+ data.variants[i].inventory_quantity +'" data-variant-id="' + values + '"' + 'data-url="' + Utils.buildProductItemUrl(data)+'?variant='+data.variants[i].id+ '"' + 'class="product-each-selection product-option-con  desktop-mb-10 show-mobile-inline-block ">';
				    if(color_exist) {
						colorSwatchesHtml += '<div class="product-option-title-con flex-row indiviudal-swatch cursor">' + color + '</div>';
					}
				}
			} else
			{

				for (var index = 0; index < data.options.length; index++) {
					var option = data['options'][index].toLowerCase();

					// for(i = 0; i < data.options_with_values.length; i++){
					// 	var optionss = data['options'][i];
					// 	var frags = optionss.split('_');
					// 	for (i=0; i<frags.length; i++) {
					//       frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
					//       var optionss = frags.join(' ');
					//     }
					// }

					// if (optionss.includes('Size') || optionss.includes('Length') ){
					// 	colorSwatchesHtml += '<a class="global-button-border" id="choose-button"' + 'value="' + optionss + '"' + 'href="' + Utils.buildProductItemUrl(data)+'?variant='+data.id+ '"' + '>' + "Choose";
					// 	colorSwatchesHtml += '</a>';
					// }

					if (option == 'color') {
						var colorlist = '';
						var color = '';
						var totalVariants = 0;
						for (var k = 0; k < data.variants.length; k++) {
							var variant = data['variants'][k];
							color = variant['options'][index];
							if (colorlist.indexOf(color) == -1) {
								var text = Utils.slugify(color);
								var border = text == 'white' ? 'border: 1px solid #cbcbcb;' : '';
								var backgroundImage = Utils.optimizeImage(variant.image, '24x');
								var dataImg = '';
								var dataColor = '#fff';
								dataColors = variant.option_color.toLowerCase().split(' ');
								var i = dataColors.length - 1;
								if (dataColors[i] !== '' && dataColors[i] !== 'colors') {
									dataColor = dataColors[i];
								}
								title_handle = data.tags;

								var Gold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#d3b47b" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#d3b47b" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#d3b47b" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
								var Silver = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#dbdbdb" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#dbdbdb" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#dbdbdb" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
								var RoseGold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#d8996b" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#d8996b" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#d8996b" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
								var WhiteGold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#dbdbdb" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#dbdbdb" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#dbdbdb" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'
								var YellowGold = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve"><path fill="#ceb582" d="M25,0c-3.75,0-7.3,0.83-10.49,2.31v45.38C17.7,49.17,21.25,50,25,50c13.81,0,25-11.19,25-25S38.81,0,25,0z"/><g><path fill="#ceb582" d="M0,24.97C0,14.91,5.94,6.25,14.51,2.28V-7.3h-61.69v61.69h61.69v-6.72C5.94,43.7,0,35.03,0,24.97z"/><path fill="#ceb582" d="M0,24.97C0,35.03,5.94,43.7,14.51,47.67V2.28C5.94,6.25,0,14.91,0,24.97z"/></g></svg>'

								if (variant.image !== null) {
									dataImg = "data-img='" + Utils.optimizeImage(variant.image) + "'";
								} else {
									var _file = variant.option_color.toLowerCase().replace(/ /g, '-');
									backgroundImage = boostPFSAppConfig.general.file_url.split('?')[0] + 'color-' + _file + '.png';
								}

								if (color == 'Gold' || title_handle.includes('Gold')){
									//console.log(c.innerHTML + "Gold Color Swatch");
									color = '' + Gold;
									//c.data = 'content2';
									//c.setAttribute("data-variant", "Gold");
								} else if (color == 'Silver' || title_handle.includes('Silver') || color.includes('Silver') ){
									color = '' + Silver;
									//c.setAttribute("data-variant", "Silver");

								} else if (color == 'Rose gold' || color == 'Rose Gold' || title_handle.includes('Rose gold') || title_handle.includes('Rose Gold') ){
									color = '' + RoseGold;
									//c.setAttribute("data-variant", "Rose gold");
								} else if (color == 'White gold' || color == 'White Gold' ){
									color = '' + WhiteGold;
									//c.setAttribute("data-variant", "White gold");
								} else if (color == 'Yellow gold' || color == 'Yellow Gold' ){
									color = '' + YellowGold;
									//c.setAttribute("data-variant", "Yellow gold");
								} else{
									color = variant['options'][i];
								}

								colorSwatchesHtml += '<div data-inventory-qty="'+ data.variants[k].inventory_quantity +'" data-variant-id="' + data.variants[k].id + '"' + 'data-url="' + Utils.buildProductItemUrl(data)+'?variant='+data.variants[k].id+ '"' + 'class="product-each-selection product-option-con  desktop-mb-10 show-mobile-inline-block ">';
								colorSwatchesHtml += '<div class="product-option-title-con flex-row indiviudal-swatch cursor">' + color + '</div>';
								
								// colorSwatchesHtml += '<div data-variant-id="" class="product-each-selection product-option-con  desktop-mb-10 show-mobile-inline-block ">';
								// colorSwatchesHtml += '<div class="product-option-title-con flex-row indiviudal-swatch cursor">' + color + '</div>';
								//colorSwatchesHtml += '<label style="' + border + ' background-color: ' + dataColor + '; background-image: url(' + backgroundImage + ');" ' + dataImg + '></label>';

								//colorSwatchesHtml += '<label style="' + border + 'background-image: url(' + Utils.optimizeImage(variant.image, '24x') + ');"' + if (variant.image !== null){ + 'data-img="' + Utils.optimizeImage(variant.image) + '"' + } '></label>';
								colorSwatchesHtml += '</div>';

							}
							var templist = colorlist + color + ' ';
							colorlist = templist;

							totalVariants++;
						}
					}
				}
			}
		}
		colorSwatchesHtml += '</div>';
	}
	return colorSwatchesHtml;
	}





	// Build Custom Color Select Swatches (Shah)
	function buildCustomColorSelectSwatches(data) {
	var colorSwatchesHtml = '';
	if (boostPFSThemeConfig.custom.display_item_swatch) {
		// colorSwatchesHtml += '<select id="product-select-variant" class="product-select" data-variant="'+data.variants.length+'">';

		if (data.variants.length == 1) {
			colorSwatchesHtml += '<select id="product-select-variant" class="product-select" data-variant="'+data.variants.length+'" data-inventory="'+data['variants'][0].inventory_quantity+'">';
			//console.log("hihi")
			for(i = 0; i < data.options_with_values.length; i++)
			{
				values = data.options_with_values[i]["values"];
				var option = data['options'][i].toLowerCase();
				for(k = 0; k < values.length; k++)
				{
					for(j = 0; j < data.variants.length; j++)
					{
						values = data.variants[j].id;
						var variant = data['variants'][j];
						color = variant['options'][i];

					    // colorSwatchesHtml += '<option value="' + values + '"' + 'data-url="' + Utils.buildProductItemUrl(data)+'?variant='+data.variants[j].id+ '"' + 'data-price="' + Utils.formatMoney(data.price_min)+ '"' + 'data-available="' + data['variants'][j].available+ '"' + 'data-inventory="' + data['variants'][j].inventory_quantity+ '"' +  '>' + color;
					    // colorSwatchesHtml += '</option>';

						colorSwatchesHtml += '<option class="option-color" value="' + values + '"' + 'data-url="' + Utils.buildProductItemUrl(data)+'?variant='+data.variants[j].id+ '"' + 'data-price="' + data.price_min+ '"' + ' data-available="' + data['variants'][j].available+ '"' + ' data-inventory="' + data['variants'][j].inventory_quantity+ '"' +  '>' + color;
					    colorSwatchesHtml += '</option>';
					}
				
				}
			}
		} else
		{
			colorSwatchesHtml += '<select id="product-select-variant" class="product-select" data-variant="'+data.variants.length+'" data-inventory="'+data['variants'][0].inventory_quantity+'">';
			for (var index = 0; index < data.options.length; index++) {
				var option = data['options'][index].toLowerCase();
				if (option == 'color') {
					var colorlist = '';
					var color = '';
					var totalVariants = 0;
					for (var k = 0; k < data.variants.length; k++) {
						var variant = data['variants'][k];
						color = variant['options'][index];
						if (colorlist.indexOf(color) == -1) {
							if (totalVariants < 4) {
								var text = Utils.slugify(color);
								var border = text == 'white' ? 'border: 1px solid #cbcbcb;' : '';
								var backgroundImage = Utils.optimizeImage(variant.image, '24x');
								var dataImg = '';
								var dataColor = '#fff';
								dataColors = variant.option_color.toLowerCase().split(' ');
								var i = dataColors.length - 1;
								if (dataColors[i] !== '' && dataColors[i] !== 'colors') {
									dataColor = dataColors[i];
								}
								if(data.variants[k].image !== null && data.variants[k].image){
									//images[k].id
									var variantImage = data.variants[k].image;
									var imageInfo = data.images_info.filter(function(image){
									return image.src === variantImage
									})
									if(imageInfo.length > 0){
										var imageID = imageInfo[0].id;
										//images = data.images_info
										// colorSwatchesHtml += '<option value="' + data.variants[k].id + '"' + 'data-url="' + Utils.buildProductItemUrl(data)+'?variant='+data.variants[k].id+ '"' + 'data-image="' + imageID + '"' + 'data-available="' + data['variants'][k].available+ '"' + 'data-inventory="' + data['variants'][k].inventory_quantity+ '"' + 'data-price="' + Utils.formatMoney(data.price_min)+ '"' + 'data-compare-at-price="' + '"' + 'class="">' + color;

										colorSwatchesHtml += '<option class="option-color" value="' + data.variants[k].id + '"' + 'data-url="' + Utils.buildProductItemUrl(data)+'?variant='+data.variants[k].id+ '"' + 'data-image="' + imageID + '"' + 'data-available="' + data['variants'][k].available+ '"' + 'data-inventory="' + data['variants'][k].inventory_quantity+ '"' + 'data-price="' + data.price_min+ '"' + ' data-compare-at-price="' + '"' + ' class="">' + color;
										//colorSwatchesHtml += '<div class="product-option-title-con flex-row indiviudal-swatch cursor">' + color + '</div>';
										
										colorSwatchesHtml += '</option>';
									}
								}

								// images = data.images_info
								// colorSwatchesHtml += '<option value="' + data.variants[k].id + '"' + 'data-url="' + Utils.buildProductItemUrl(data)+'?variant='+data.variants[k].id+ '"' + 'data-image="' + data['images_info'][k].id + '"' + 'data-available="' + data['variants'][k].available+ '"' + 'data-inventory="' + data['variants'][k].inventory_quantity+ '"' + 'data-price="' + Utils.formatMoney(data.price_min)+ '"' + 'class="">';
								// //colorSwatchesHtml += '<div class="product-option-title-con flex-row indiviudal-swatch cursor">' + color + '</div>';
								
								// colorSwatchesHtml += '</option>';

							}
							var templist = colorlist + color + ' ';
							colorlist = templist;

							totalVariants++;

						}
					}
				}
			}
		}
		colorSwatchesHtml += '</select>';
	}
	return colorSwatchesHtml;
	}

	function buildButton(data){
		let colorSwatchesHtml = '';

		if(data.template_suffix == "" || data.template_suffix == null)
		{
			colorSwatchesHtml += '<button type="button" class="pt-5 pb-5 quick-view-con hide-mobile show-desktop product-each-popup-button" data-handle="'+data.handle+'" data-product-id="'+data.id+'" data-id="product-popup-'+data.id+'">Quick View</button>';
		}
		return colorSwatchesHtml;
		
	}


	// Build Custom Add Cart (Shah)
    function buildCustomAddCart(data) {
		let colorSwatchesHtml = '';
		if(data.template_suffix == "" || data.template_suffix == null) {
			let luxuryTagIndex = data.tags.findIndex(tag => tag == 'luxury');
			const wholesale = $('.collection-products').data('wholesale');
			const resText = $('.collection-products').data('wholesale-res-text');
			let qty_value = 1;

			/* exclude 14k */
			if(data.tags.findIndex(tag => tag == '14K Solid Gold') > -1) {
				luxuryTagIndex = -1;
				qty_value = $360_14k_min_purchase;
			}
			
			if(wholesale && luxuryTagIndex > -1) {
				colorSwatchesHtml += `<p class="product-each-form-text mt-5 luxury-msg"><a href="mailto:wholesale@jcojewellery.com?subject=Enquiry on {{ product.title }}&&body=Hi!%0D%0A%0D%0AI would like to get the price list for {{ product.title }}%0D%0A%0D%0AThank you!">${resText}</a></p>`;
			} else {
				colorSwatchesHtml += '<form class="product-each-form product-quick-add-con text-center pt-10">';
				if (boostPFSThemeConfig.custom.display_item_swatch) {
					if (data.available == true) {
						if (data.variants.length == 1) {
							colorSwatchesHtml += '<div style="display: none;"' + '>';
								colorSwatchesHtml += '<div class="qty-div cf global-quantity-div"' +  'id="quickqty' + data.id + '"'  + '>';
									colorSwatchesHtml += '<input type="button" class="qtyminus" value="-" >';
									colorSwatchesHtml += '<input type="text" class="qty" name="quantity" value="'+ qty_value +'"' + 'id="quickquantity' + data.id  + '"'  + 'value="' + data.id  + '"' + '>';
									colorSwatchesHtml += '<input type="button" class="qtyplus global-plus" value="+"' + 'id="quickmax' + data.id  + '"' + 'data-max="quickmax' +  data.inventory_quantity  + '"' + '>';
								colorSwatchesHtml += '</div>';	
							colorSwatchesHtml += '</div>';
							colorSwatchesHtml += '<input type="hidden"' + 'id="variant' + data.id + '"' + 'value="' + data.id + '"' + '>';
							colorSwatchesHtml += '<button type="submit" data-inventory-qty="'+ data.variants[0].inventory_quantity +'" data-min-add="'+ qty_value +'" class="global-quick-add global-button-border"' + 'id="quickbutton' + data.id + '"' + 'data-variant="variant' + data.id + '"' + 'data-quantity="quickquantity' + data.id + '"' + '>' + "Add to bag";
							colorSwatchesHtml += '</button>';
						} else {
							for(i = 0; i < data.options_with_values.length; i++) {
								values = data.options_with_values[i]["values"];
								var optionss = data['options'][i];
								var frags = optionss.split('_');
								for (i=0; i<frags.length; i++) {
									frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
									var optionss = frags.join(' ');
								}

								if (optionss.includes('Size') || optionss.includes('Length') ) {
									colorSwatchesHtml += '<a class="global-button-border" id="choose-button"' + 'value="' + optionss + '"' + 'href="' + Utils.buildProductItemUrl(data)+'?variant='+data.id+ '"' + '>' + "Choose";
									colorSwatchesHtml += '</a>';
								} else {
									for(var k = 0; k < data.variants.length; k ++) {
										if(data.variants[k].image !== null && data.variants[k].image) {
											var variantImage = data.variants[k].image;
											//data['variants'][j].inventory_quantity
											var imageInventory = data.variants[k].inventory_quantity;
											var imageInfo = data.images_info.filter(function(image) {
												return image.src === variantImage
											})
											if(imageInfo.length > 0) {
												var imageID = imageInfo[0].id;
												;
											}
										}
									}

									productTitle = data.title.toLowerCase().replace(/ /g,'-');
									
									colorSwatchesHtml += '<div style="display: none;"' + '>';
										colorSwatchesHtml += '<div class="qty-div cf global-quantity-div"' +  'id="quickqty' + data.id + '"'  + '>';
											colorSwatchesHtml += '<input type="button" class="qtyminus" value="-" >';
											colorSwatchesHtml += '<input type="text" class="qty" name="quantity" value="'+ qty_value +'"' + 'id="quickquantity' + data.id  + '"'  + 'value="' + data.id  + '"' + '>';
											colorSwatchesHtml += '<input type="button" class="qtyplus global-plus" value="+"' + 'id="quickmax' + data.id  + '"' + 'data-max="quickmax' +  data.inventory_quantity  + '"' + '>';
										colorSwatchesHtml += '</div>';	
									colorSwatchesHtml += '</div>';
									colorSwatchesHtml += '<input type="hidden"' + 'id="variant' + data.id + '"' + 'value="' + data.id + '"' + '>';
									colorSwatchesHtml += '<button type="submit" data-inventory-qty="'+ data.variants[0].inventory_quantity +'" data-min-add="'+ qty_value +'" class="global-quick-add global-button-border wef"' + 'id="quickbutton' + data.id + '"' + 'data-variant="variant' + data.id + '"' + 'data-quantity="quickquantity' + data.id + '"' + '>' + "Add to bag";
									colorSwatchesHtml += '</button>';
									colorSwatchesHtml += '<button href="#" class="BIS_trigger global-add-button black btn"' + 'data-product-handle="' + productTitle + '"' + 'style="display: none;"' + '>' + "Join Waitlist";
									colorSwatchesHtml += '</button>';
								}
							}
						}

						if(data.tags.findIndex(tag => tag == '14K Solid Gold') > -1) {
							colorSwatchesHtml += `<div class="pe-form-error-14k mt-10 hide-mobile">${$360_14k_min_purchase_error_message}</div>`;
						}
					} else {
						var proTitle = data.title;
						proTitle = proTitle.toLowerCase().replace(/ /g,'-');
						colorSwatchesHtml += '<button href="#" data-product-data="" class="BIS_trigger global-add-button black btn"' + 'data-product-handle="' + proTitle + '"' + '>' + 'join waitlist';
						colorSwatchesHtml += '</button>';
					}
				}

				colorSwatchesHtml += '</form>';
			}
		} else
		{
			colorSwatchesHtml += '<a href="/products/'+data.handle+'" class="global-button-border mt-10">View Details</a>';
		}
		return colorSwatchesHtml;
    }

	// Build Color Swatches
	function eventColorSwatches() {
		jQ('.boost-pfs-filter-item-swatch li label').each(function(){
			var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
			jQ(this).hover(function(){
				var newImage = jQ(this).data('img');
				img.attr('srcset', newImage);
			});
		});
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}
		if (Settings.getSettingValue('general.paginationType') == 'default') {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}
	};
	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					activeClass = '';
					if(paramSort == k) {
						activeClass = 'active';
					}
					sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass+ '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		if (paramSort.length > 0) {
			var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
			labelSort = Labels[labelHandle];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e){
			e.preventDefault();
			FilterApi.setParam('page', 1);
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.applyFilter('sort');
		});

		jQ(".boost-pfs-filter-custom-sorting > button").click(function(){
			if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
				jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
				//jQ('.boost-pfs-filter-tree-v').hide();
			}
		});

		function calcProductImage() {
		    let mostHeight = -1
		    $(".product-each .image-link").attr("style", "")
		    $(".product-each .image-link").each(function() {
		    mostHeight = mostHeight > $(this).outerHeight() ? mostHeight : $(this).outerHeight()
		    })
		    $(".product-each .image-link").each(function() {
		    $(this).css("height", mostHeight)
		    })
		}

		function calcProductTitle() {
		    let mostHeight = -1
		    $(".product-each .boost-pfs-filter-product-item-title").attr("style", "")
		    $(".product-each .boost-pfs-filter-product-item-title").each(function() {
		    mostHeight = mostHeight > $(this).outerHeight() ? mostHeight : $(this).outerHeight()
		    })
		    $(".product-each .boost-pfs-filter-product-item-title").each(function() {
		    $(this).css("height", mostHeight)
		    })
		}

		$(document).ready(function() {
		    calcProductImage();
		    calcProductTitle();
			console.log('DATA READY....');
			
			// hide color swatches for single product (has no color variant)
			$(".product-each").each(function(idx) {
				var dataVariant = parseInt($(this).find('.product-options-form .product-each-selection').length);
				// var dataVariant = parseInt($(this).find('.product-select').attr('data-variant'));
				// console.log('dataVariant', dataVariant);
				if (dataVariant == 1) {
					// console.log('single', idx);
					var vQty = parseInt($(this).find('.product-select').attr('data-inventory'));
					// console.log('vQty'+idx+'', vQty);
					if (isNaN(vQty)) {
						var vQty = parseInt($(this).find('.product-select > option').eq(0).attr('data-inventory'));
						// console.log('vQty'+idx+'', vQty);
					}
					// var vQty = parseInt($(this).find('.product-select > option').eq(0).attr('data-inventory'));
					if (vQty > 0 && vQty < 5) {
						$(this).find('.fast').removeClass('hide');
					}
					$(this).find('.product-options-form').css('display', 'none');
				} else {
					// console.log('vary', idx);
				}
			})
		});

		$(window).on("load resize", function() {
		    calcProductImage();
		    calcProductTitle();
			console.log('DATA LOADED....');
		})

		calcProductImage();
		calcProductTitle();

		$("body").on("click",".boost-pfs-filter-load-more-button",function(e){
		    calcProductImage();
			calcProductTitle();
		});

		jQ(Selector.filterTreeMobileButton).click(function(){
			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		});
	};
	// For Toolbar - Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};
	
	// Build Show Limit
	ProductLimit.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
			
			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k in sortingArr) {
					showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};
	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
				if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
					breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				} else {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				}
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			}
		}
		return breadcrumbItemsHtml
	};
	/************************** END BUILD TOOLBAR **************************/
	// function matchHeightImage() {
	// 	// jQ('.boost-pfs-filter-product-item-main-image').load(function() {
	// 	// 	var imageContainer = jQ(this).parent();
	// 	// 	imageContainer.css('width', '100%').css('height', jQ(this).height());
	// 	// }).each(function() {
	// 	// 	if (this.complete) jQ(this).load();
	// 	// });
	// }

	
	
	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		eventColorSwatches();
		if (!data) data = this.data;
		!function(){e=function(){"use strict";window.innerShiv=function(){function n(e,t,r){return/^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(r)?e:t+"></"+r+">"}var s,o=document,d="abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(" ");return function(e,t){if(!s&&((s=o.createElement("div")).innerHTML="<nav></nav>",1!==s.childNodes.length)){for(var r=o.createDocumentFragment(),a=d.length;a--;)r.createElement(d[a]);r.appendChild(s)}if(e=e.replace(/^\s\s*/,"").replace(/\s\s*$/,"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"").replace(/(<([\w:]+)[^>]*?)\/>/g,n),s.innerHTML=(r=e.match(/^<(tbody|tr|td|col|colgroup|thead|tfoot)/i))?"<table>"+e+"</table>":e,r=r?s.getElementsByTagName(r[1])[0].parentNode:s,!1===t)return r.childNodes;a=o.createDocumentFragment();for(var i=r.childNodes.length;i--;)a.appendChild(r.firstChild);return a}}()},t={exports:{}},e.call(t.exports,t,t.exports),t.exports;var e,t;(function(){window.SPR=function(){function n(){}return n.shop=Shopify.shop,n.host="//productreviews.shopifycdn.com",n.version="v4",n.api_url=n.host+"/proxy/"+n.version,n.badgeEls=[],n.reviewEls=[],n.elSettings={},n.$=void 0,n.extraAjaxParams={shop:n.shop},n.registerCallbacks=function(){return this.$(document).bind("spr:badge:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onBadgeLoad:void 0),this.$(document).bind("spr:product:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onProductLoad:void 0),this.$(document).bind("spr:reviews:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onReviewsLoad:void 0),this.$(document).bind("spr:form:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormLoad:void 0),this.$(document).bind("spr:form:success","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormSuccess:void 0),this.$(document).bind("spr:form:failure","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormFailure:void 0)},n.loadStylesheet=function(){var e;return(e=document.createElement("link")).setAttribute("rel","stylesheet"),e.setAttribute("type","text/css"),e.setAttribute("href","https://productreviews.shopifycdn.com/assets/v4/spr-805222bdeda8199e3a86a468a398e3070e6126868692225ffa23ac7502b1eca2.css"),e.setAttribute("media","screen"),document.getElementsByTagName("head")[0].appendChild(e)},n.initRatingHandler=function(){return n.$(document).on("mouseover mouseout","form a.spr-icon-star",function(e){var t,r,a;return t=e.currentTarget,a=n.$(t).attr("data-value"),r=n.$(t).parent(),"mouseover"===e.type?(r.find("a.spr-icon:lt("+a+")").addClass("spr-icon-star-hover"),r.find("a.spr-icon:gt("+(a-1)+")").removeClass("spr-icon-star-hover")):r.find("a.spr-icon").removeClass("spr-icon-star-hover")})},n.initDomEls=function(){return this.badgeEls=this.$(".shopify-product-reviews-badge[data-id]"),this.reviewEls=this.$("#shopify-product-reviews[data-id]"),this.$.each(this.reviewEls,(a=this,function(e,t){var r;return r=a.$(t).attr("data-id"),a.elSettings[r]={},a.elSettings[r].reviews_el="#"+(a.$(t).attr("data-reviews-prefix")?a.$(t).attr("data-reviews-prefix"):"reviews_"),a.elSettings[r].form_el="#"+(a.$(t).attr("data-form-prefix")?a.$(t).attr("data-form-prefix"):"form_")}));var a},n.loadProducts=function(){return this.$.each(this.reviewEls,(i=this,function(e,t){var r,a;if(r=i.$(t).attr("data-id"),"false"!==i.$(t).attr("data-autoload"))return a=i.$.extend({product_id:r,version:i.version},i.extraAjaxParams),i.$.get(i.api_url+"/reviews/product",a,i.productCallback,"jsonp")}));var i},n.loadBadges=function(){var e,t,r,a,i,n;if(0<(r=this.$.map(this.badgeEls,(n=this,function(e){return n.$(e).attr("data-id")}))).length){for(t=7,i=[];0<(e=r.splice(0,t)).length;)a=this.$.extend(this.extraAjaxParams,{product_ids:e}),i.push(this.$.get(this.api_url+"/reviews/badges",a,this.badgesCallback,"jsonp"));return i}},n.pageReviews=function(e){var t,r,a;return a=this.$(e).data("product-id"),r=this.$(e).data("page"),t=this.$.extend({page:r,product_id:a},this.extraAjaxParams),this.$.get(this.api_url+"/reviews",t,this.paginateCallback,"jsonp"),!1},n.submitForm=function(e){var t,r,a;return t=this.$(e).serializeObject(),t=this.$.extend(t,this.extraAjaxParams),t=(t=this.$.param(t)).replace(/%0D%0A/g,"%0A"),this.$.ajax({url:this.api_url+"/reviews/create",type:"GET",dataType:"jsonp",data:t,success:this.formCallback,beforeSend:(a=this,function(){return a.$(".spr-button-primary").attr("disabled","disabled")}),complete:(r=this,function(){return r.$(".spr-button-primary").removeAttr("disabled")})}),!1},n.reportReview=function(e){var t;return confirm("Are you sure you want to report this review as inappropriate?")&&(t=this.$.extend({id:e},this.extraAjaxParams),this.$.get(this.api_url+"/reviews/report",t,this.reportCallback,"jsonp")),!1},n.toggleReviews=function(e){return this.$("#shopify-product-reviews[data-id='"+e+"']").find(".spr-reviews").toggle()},n.toggleForm=function(e){return this.$("#shopify-product-reviews[data-id='"+e+"']").find(".spr-form").toggle()},n.setRating=function(e){var t,r,a;return t=this.$(e).parents("form"),a=this.$(e).attr("data-value"),r=this.$(e).parent(),t.find("input[name='review[rating]']").val(a),this.setStarRating(a,r)},n.setStarRating=function(e,t){return t.find("a:lt("+e+")").removeClass("spr-icon-star-empty spr-icon-star-hover"),t.find("a:gt("+(e-1)+")").removeClass("spr-icon-star-hover").addClass("spr-icon-star-empty")},n.badgesCallback=function(e){var r;return r=e.badges,n.$.map(n.badgeEls,function(e){var t;if(t=n.$(e).attr("data-id"),r[t]!==undefined)return n.$(e).replaceWith(r[t]),n.triggerEvent("spr:badge:loaded",{id:t})})},n.productCallback=function(e){var t;return t=e.remote_id.toString(),n.renderProduct(t,e.product_stripped,e.aggregate_rating),n.renderForm(t,e.form),n.renderReviews(t,e.reviews)},n.renderProduct=function(t,r,a){return this.$.map(this.reviewEls,(i=this,function(e){if(t===i.$(e).attr("data-id"))return i.$(e).html([innerShiv(r,!1),a]),i.triggerEvent("spr:product:loaded",{id:t})}));var i},n.renderForm=function(e,t){return this.$(this.elSettings[e].form_el+e).html(t),this.triggerEvent("spr:form:loaded",{id:e})},n.renderReviews=function(e,t){return n.$(n.elSettings[e].reviews_el+e).html(t),n.triggerEvent("spr:reviews:loaded",{id:e})},n.formCallback=function(e){var t,r,a,i;return i=e.status,a=e.remote_id,r=e.form,(t=n.$(n.elSettings[a].form_el+a)).html(r),"failure"===i&&n.initStarRating(t),"success"===i&&(n.$("#shopify-product-reviews[data-id='"+a+"'] .spr-summary-actions-newreview").hide(),n.$(".spr-form-message-success").focus()),n.triggerEvent("spr:form:"+i,{id:a})},n.initStarRating=function(e){var t,r,a;if((a=e.find("input[name='review[rating]']"))&&a.val())return r=a.val(),t=e.find(".spr-starrating"),this.setStarRating(r,t)},n.paginateCallback=function(e){var t,r;return r=e.remote_id.toString(),t=e.reviews,n.renderReviews(r,t)},n.reportCallback=function(e){var t;return t="#report_"+e.id,n.$(t).replaceWith("<span class='spr-review-reportreview'>"+n.$(t).attr("data-msg")+"</span>")},n.loadjQuery=function(e){return n.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",function(){return n.$=jQuery.noConflict(!0),e()})},n.loadScript=function(e,t){var r;return(r=document.createElement("script")).type="text/javascript",r.readyState?r.onreadystatechange=function(){if("loaded"===r.readyState||"complete"===r.readyState)return r.onreadystatechange=null,t()}:r.onload=function(){return t()},r.src=e,document.getElementsByTagName("head")[0].appendChild(r)},n.loadjQueryExtentions=function(r){return r.fn.serializeObject=function(){var e,t;return e={},t=this.serializeArray(),r.each(t,function(){return e[this.name]?(e[this.name].push||(e[this.name]=[e[this.name]]),e[this.name].push(this.value||"")):e[this.name]=this.value||""}),e}},n.triggerEvent=function(e,t){return this.$(document).trigger(e,t)},n}(),SPR.loadStylesheet(),SPR.loadjQuery(function(){return SPR.$.ajaxSetup({cache:!1}),SPR.loadjQueryExtentions(SPR.$),SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})})}).call(this)}("undefined"!=typeof global?global:"undefined"!=typeof window&&window);
      
        setTimeout(calcProductImage, 1000);
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
		
		jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

		// Prevent double tap on iOS
		var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (isiOS){
			Utils.isMobile()&&jQ(".boost-pfs-filter-product-item").find("a").on("touchstart",function(){isScrolling=!1}).on("touchmove",function(){isScrolling=!0}).on("touchend",function(){isScrolling||(window.location=jQ(this).attr("href"))});
		}

		// Fix image not loaded on mobile
		//(Utils.isMobile()||null!=navigator.userAgent.match(/iPad/i))&&(setTimeout(function(){jQ(".boost-pfs-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},200),setTimeout(function(){jQ(".boost-pfs-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"3";jQ(this).attr("src",a)})},2e3));
	};
  
  	FilterTree.prototype.renderExtraElements = function(){
      if (this.$element.find(this.selector.applyAllButton).length == 0) {
        this.$element.find(this.selector.applyAllButtonContainer).append(this.applyAllButton.$element);
        // impulse theme 
        var self = this;
        this.applyAllButton.$element.click(function() {
          jQ(this).parents('.boost-pfs-filter-tree').find(self.selector.closeFilter).click();
        });        
      }
      
      this.applyAllButton.$element.css({
        display: 'block',
        'text-align': 'center',        
      });
    }; 
  
 	FilterOptionRangeSlider.prototype.afterInit = function() {
      if (Utils.isMobile()) this.requestInstantly = false;
    }
  
    FilterOptionItemMultiLevelCollections.prototype.afterInit = function() {      
      if (Utils.isMobile()) this.requestInstantly = false;
    }
    
    FilterOptionItemMultiLevelTag.prototype.afterInit = function() {      
      if (Utils.isMobile()) this.requestInstantly = false;
    }
  
    FilterOptionItem.prototype.afterInit = function() {         
      if (Utils.isMobile()) this.requestInstantly = false;
    }  

	// Function after filter
	FilterResult.prototype.afterRender = function() {
		setInterval(() => {
			const product_item_height = document.querySelector('.right-image .product-each a').style.height;
			if(product_item_height == '0px') {
				setProductItemHeight();
			}
		}, 1000);

		setProductItemHeight();

		function setProductItemHeight() {
			// var data = this.data;
			document.querySelectorAll('.swatches-con').forEach(el => {
				const priceEl = el.querySelector('.product-each-name-price');
				const tabletEl = el.querySelector('.pb-15.tablet-pb-10');

				if(tabletEl) {
					el.insertAdjacentElement('afterend', tabletEl);
				}

				if(priceEl) {
					el.insertAdjacentElement('afterend', priceEl);
				}
			});

			// Calculate product image height
			calcProductImage();
			calcProductSwatch();
			// calcProductTitle();
			// calcProductNamePrice();
			// calcProductQuickAdd();
			// calcProductStars();
		}
	}

})();
